import router from "@/router";
import axios from "axios";

// 加载注册offline路由
const offlineRoute = {
  path: '/404',
  name: 'offline',
  component: ()=> import('../../offline.vue'),
  meta: {
  title: '活动结束',
    errorPageFlag: true
  }
}
const registerPageRoute = function (route) {
  router.addRoutes([offlineRoute])
}

// 项目启动 加载offline跳转逻辑
const beforeEnterPageHandle = function () {
  return router.beforeEach(async (to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
      document.title = to.meta.title
    }
    // 判断是否为促销页面 code!== 'undifend'
    // 或者是否为404页面 errorPageFlag!== 'undifend'
    if(to.meta.code || to.meta.errorPageFlag) {
      // 为促销页面 判断促销是否已下线 下线跳404 在线跳过
      if(!to.meta.errorPageFlag) {
        const { data } = await axios.get(`/crm/promote/sales/check?code=${to.meta.code}`)
        if(data && data.code === 0) {
          if(!data.data) {
            next({ path: '/404'})
            return
          }
          next()
        } else {
          next()
        }
      } else {
        next()
      }
    }else {
      next()
    }
  })
}


export const loadOffline = ()=> {
  registerPageRoute()
  beforeEnterPageHandle()
}






// WEBPACK FOOTER //
// ./src/components/Offline/assets/js/enterPageHandle.js